import React from 'react'
import { Route, IndexRoute } from 'react-router'

import CoreLayout from 'components/layouts/CoreLayout'
import Auth from 'components/layouts/Auth'
import Error404 from 'components/Errors/Error404'

import Dashboard from './dashboard'
import Finances from './finances'
import Profile from './profile'
import PropertyForm from './propertyForm'
import ApplicationForm from './applicationForm'
import TaskForm from './taskForm'
import TenantForm from './tenantForm'
import LeaseForm from './leaseForm'
import TermForm from './termForm'
import ProjectForm from './projectForm'
import TransactionForm from './transactionForm'
import ListingForm from './listingForm'

export default config => (
	<Route component={CoreLayout} >
		<Route component={Auth} path="/landlord">
				<IndexRoute component={Dashboard} />
				<Route component={Dashboard} path="/landlord/home"/>
				<Route component={Profile} path="/landlord/profile/:id" />
				<Route component={PropertyForm} path="/landlord/property/:id" />
				<Route component={Finances} path="/landlord/finances"/>
				<Route component={TaskForm} path="/landlord/task/:id" />
				<Route component={ProjectForm} path="/landlord/project/:id" />
		    <Route component={TransactionForm} path="/landlord/transaction/:id" />
		    <Route component={LeaseForm} path="/landlord/lease/:id" />
		    <Route component={TermForm} path="/landlord/term/:id" />
		    <Route component={TenantForm} path="/landlord/tenant/:id" />
				<Route component={ApplicationForm} path="/landlord/application/:id" />
				<Route component={ListingForm} path="/landlord/listing/:id" />
		</Route>
    <Route path="*" component={Error404}/>
	</Route>
)



// WEBPACK FOOTER //
// ./src/routes/landlord/index.js